import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

interface ConstrainedWrapperProps {
  children: ReactNode;
  maxWidth?: number | string;
}

export default function ConstrainedWrapper({ children, maxWidth = 600 }: ConstrainedWrapperProps) {
  return (
    <Box sx={{ maxWidth, mx: 'auto', width: '100%' }}>
      {children}
    </Box>
  );
}
